// Functional component for the navbar / restaurant selection

import { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import RestaurantBadge from "./RestaurantBadge";
import SortIcon, { Icon } from "./SortIcon";
import React from "react";
import { ThemeContext } from "../App";
import { Restaurant } from "../models/RestaurantInfo";

interface NavbarProps {
    selectedRestaurantID: number;
    clickHandler(ID: number): void;
    restaurants: Restaurant[];
    navbarIsActive: boolean;
    toggleNavbar(): void;
    loadingData: boolean
}

const Navbar = (props: NavbarProps) => {
    const [sortingOption, setSortingOption] = React.useState<Icon>(Icon.Character);
    const { theme } = useContext(ThemeContext);

    /* Sort alphabetically */
    if (sortingOption === Icon.Character) {
        props.restaurants.sort((restaurantA, restaurantB) => {
            return restaurantA.restaurantName.localeCompare(restaurantB.restaurantName, "se-SE");
        });
    } 
    else if (sortingOption === Icon.Clock) {
        /* Sort by queue length */
        props.restaurants.sort((restaurantA, restaurantB) => {
            return restaurantA.queueLength - restaurantB.queueLength;
        });
    }

    // Create RestaurantBadge components for all of the restaurants
    const restaurantBadges: JSX.Element[] = props.restaurants.map(
        (restaurant) => {
            return (
                <RestaurantBadge
                    restaurant={restaurant}
                    isSelected={props.selectedRestaurantID === restaurant.restaurantID}
                    clickHandler={props.clickHandler}
                />
            );
        }
    );

  return (
        <div className={props.navbarIsActive ? "navbar navbar-active" : "navbar"}>
            <div className="xmark--container" onClick={props.toggleNavbar} id={theme}>
                <FontAwesomeIcon className="fa-solid fa-xmark" icon={faXmark} />
            </div>
            <div className="navbar--header" id={theme}>
                <h3>Sort by</h3>
                <div className="navbar--header--icons">
                    <div className="alphabetically--container">
                        <SortIcon
                            clickHandler={setSortingOption}
                            isSelected={sortingOption === Icon.Clock}
                            icon={Icon.Clock}
                        />
                    </div>
                    <div className="by-length--container">
                        <SortIcon
                            clickHandler={setSortingOption}
                            isSelected={sortingOption === Icon.Character}
                            icon={Icon.Character}
                        />
                    </div>
                </div>
            </div>
            <hr id={theme} />
            <div className="navbar--restaurants">
                {props.loadingData ? 
                // Inline styling due to not being targetable by the css for strange reasons
                <div id="loading-data" style={{display: "flex", justifyContent: "center"}}><p id="loading-data-text" style={{color: "#90b8f8"}}>Loading data...</p></div> 
                : restaurantBadges}
            </div>
        </div>
    );
};

export default Navbar;
